import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex center-layout w-100" }
const _hoisted_2 = {
  class: "flex-shrink-0",
  style: {"width":"20px"}
}
const _hoisted_3 = {
  class: "flex-grow-1",
  style: {"min-width":"0"}
}
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = {
  class: "d-flex flex-shrink-0 align-center",
  style: {"min-width":"80px"}
}
const _hoisted_6 = { class: "text-align-left ms-3 me-3 my-0" }
const _hoisted_7 = {
  class: "flex-grow-1",
  style: {"min-width":"0"}
}
const _hoisted_8 = {
  key: 0,
  class: "question-header-title",
  style: {"word-break":"break-all","white-space":"normal","width":"100%"}
}
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-start gray-text text-size-tiny mt-1"
}
const _hoisted_10 = {
  key: 0,
  class: "flex-shrink-0 text-right ms-2",
  style: {"width":"70px"}
}
const _hoisted_11 = {
  key: 0,
  class: "question-score"
}

import { ref, computed, watch, onMounted, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SlideBar from './SlideBar.vue'
import { ROUTER_NAME } from '../../router'
import { map } from 'lodash'
import Exam from '../../models/exam'
import UserExam from '../../models/user_exam'
import Question, { GroupQuestion } from '../../../api/v2/models/question'
import Assessment from '../../models/assessment'
import Skill from '../../models/skill'
import SkillItem from '../../models/skill_item'
import { LETTER_FORMAT } from '../../utils/constants'
import { ExamQScoreHistory } from '../../../api/v2/models/q_score_history'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamResultQuestionGroupList',
  props: {
    item: {},
    padding: { type: Boolean, default: false },
    selected: { default: null },
    questionNumber: {},
    exam: {},
    userExam: {},
    examQScoreHistory: { default: null }
  },
  setup(__props: any) {

const route = useRoute()
const router = useRouter()

// Get $t from Vue instance
const instance = getCurrentInstance()
const $t = instance?.proxy?.$t || ((key: string) => key)

// Props
const props = __props

// Reactive Data
const newClass = ref('question-report')

// Computed
const qScoreHistorySummary = computed(() => {
  if (!props.examQScoreHistory) {
    return null
  }
  return props.examQScoreHistory.getQScoreHistorySummary(currentQuestion.value.id)
})

const groupScoreHistorySummary = computed(() => {
  if (!props.examQScoreHistory) {
    return null
  }

  const groupSummaries = props.item.questions.map((q) => props.examQScoreHistory!.getQScoreHistorySummary(q.id))
  let totalCount = 0
  let successCount = 0

  groupSummaries.forEach((groupSummary) => {
    if (!groupSummary) {
      return
    }
    totalCount += groupSummary.totalCount
    successCount += groupSummary.successCount
  })

  if (!totalCount) {
    return null
  }

  return {
    totalCount,
    successCount,
    rate: Math.round((successCount / totalCount) * 100)
  }
})

const questionCount = computed(() => props.item.questions.length)

const title = computed(() => {
  if (currentQuestion.value.isDescriptionQuestion) {
    return $t('question.description', { format: LETTER_FORMAT.UPTITLECASE })
  }
  return `${$t('question.problem')} ${props.questionNumber}`
})

const currentQuestion = computed<Question>(() => props.item.questions[0])

const assessments = computed<Assessment[]>(() => props.item.getAssessmentsByUserExam(props.userExam))

const correctCount = computed<number>(() => props.item.getCorrectCountByUserExam(props.userExam))

const skills = computed<Skill[]>(() => props.item.skills)

const skillsName = computed<string>(() => getSkillsName(skills.value))

const skillItems = computed<SkillItem[]>(() => props.item.skillItems)

const maxScore = computed<number>(() => props.item.questions.reduce((a, b) => a + b.maxScore, 0))

const score = computed<number>(() => props.item.questions.reduce((a, b) => a + b.userScore, 0))

const isPass = computed(() => {
  if (props.exam.autoDiagnosisEnabled) { return false }
  return score.value === maxScore.value
})

const isNotFullScore = computed(() => {
  if (props.exam.autoDiagnosisEnabled) { return false }
  return score.value < maxScore.value && score.value > 0
})

const isNotPass = computed(() => {
  if (props.exam.autoDiagnosisEnabled) { return false }
  return score.value === 0
})

// Functions
function updateClass() {
  newClass.value = 'question-report'
  if (props.item.questions.find((question) => question.id === props.selected)) {
    newClass.value += ' selected-tab'
  }
  if (props.padding) {
    newClass.value += ' p-2'
  }
}

function skillItemsName(skill: Skill): string {
  const filteredSkillItems = skill.skillItems.filter((skillItem) => skillItems.value.some((item) => item.id === skillItem.id))
  return getSkillsName(filteredSkillItems)
}

function showDetail() {
  router.push({
    name: ROUTER_NAME.ANSWER_RESULT_DETAIL,
    params: {
      examId: props.exam.id.toString(),
      questionId: props.item.questions[0].id.toString()
    },
    query: route.query
  })
}

function getSkillsName(skillsArr: Skill[] | SkillItem[]): string {
  return map(skillsArr, 'name').join(', ')
}

// Watchers
watch(() => props.selected, () => {
  updateClass()
})

// Lifecycle
onMounted(() => {
  updateClass()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    class: _normalizeClass([newClass.value, "result-question-group"]),
    onClick: showDetail,
    lines: "three"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (currentQuestion.value.isTestQuestion)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (__props.exam.autoDiagnosisEnabled)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      color: "blue"
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("mdi-check", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (isPass.value)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            color: "blue"
                          }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createTextVNode("mdi-check", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          }))
                        : (isNotFullScore.value)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 1,
                              color: "green"
                            }, {
                              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode("mdi-triangle-outline", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }))
                          : (isNotPass.value)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 2,
                                color: "red"
                              }, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                  _createTextVNode("mdi-close", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              }))
                            : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createBlock(_component_v_icon, {
                key: 1,
                color: "blue"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-check", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(title.value), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (questionCount.value === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createTextVNode(_toDisplayString(currentQuestion.value.headerTitle) + " ", 1 /* TEXT */),
                    (groupScoreHistorySummary.value && currentQuestion.value.isTestQuestion && !__props.exam.autoDiagnosisEnabled)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 正解率" + _toDisplayString(groupScoreHistorySummary.value.rate) + "%(" + _toDisplayString(groupScoreHistorySummary.value.successCount) + "/" + _toDisplayString(groupScoreHistorySummary.value.totalCount) + ") ", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (__props.item.questions.length > 1 && currentQuestion.value.test)
                ? (_openBlock(), _createBlock(SlideBar, {
                    key: 1,
                    current: correctCount.value,
                    total: __props.item.questions.length,
                    align: "left"
                  }, null, 8 /* PROPS */, ["current", "total"]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        (!__props.exam.autoDiagnosisEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (__props.item.isTest)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(score.value) + " / " + _toDisplayString(maxScore.value), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"]))
}
}

})